import { Box, CardContent, Grid2, Typography } from '@mui/material';
import BasicLayout from 'pages/AuthenticationPages/_components/BasicLayout';
import { LoginFormSchema } from '../../../services/AuthService/schemas';
import zod from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useDoLogin } from '../../../services/AuthService/hooks/useMutations';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import TextFieldComponent from '../../../components/TextFieldComponent';
import { LoadingButton } from '@mui/lab';
import React from 'react';
import logo_login from 'assets/images/logoProdutos/alertai_icon_blue_dark.svg';
import testeSvg from 'assets/images/svgs/SignInSVGS/3.svg';

type LoginFormInput = zod.infer<typeof LoginFormSchema>;

const RecoverPassword = () => {
  const { control, handleSubmit } = useForm<LoginFormInput>({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: { email: '', password: '' },
  });

  const navigate = useNavigate();
  const { mutateAsync, isLoading } = useDoLogin();

  const handleLogin = (data: LoginFormInput) => {
    mutateAsync(data).then(() => {
      navigate('/lpr');
    });
  };

  return (
    <BasicLayout>
      <Card
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          position: 'absolute',
          backgroundColor: 'transparent',
        }}
      >
        <Grid2
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ height: '100%' }}
        >
          <img src={testeSvg} alt="Desenho" width={500} />
        </Grid2>
        <CardContent
          sx={{
            backgroundColor: 'transparent',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box pt={4} pb={6} px={3} sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '14vh',
              }}
            >
              <img src={logo_login} width={260} />
            </Box>

            <Box
              onSubmit={() => handleSubmit(handleLogin)}
              sx={{ width: '100%' }}
            >
              <Typography color="white" variant="h4" marginY={'20px'}>
                Recuperar Senha
              </Typography>

              <Box mb={3}>
                <Typography color="gray">
                  Para recuperar sua senha, informe o email cadastrado e lhe
                  <br></br>
                  enviaremos um link com as intruções.
                </Typography>
              </Box>

              <Box mb={1}>
                <Controller
                  control={control}
                  name={'email'}
                  render={({ field: { value, onChange } }) => (
                    <TextFieldComponent
                      id="outlined-secondary"
                      type="email"
                      label="Email"
                      fullWidth
                      value={value}
                      onChangeText={onChange}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'end',
                }}
              >
                <LoadingButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  href="/app/authentication/tokenPassword"
                  loadingPosition="start"
                  sx={{
                    marginX: '10px',
                    width: '70%',
                  }}
                >
                  Enviar link de recuperação
                </LoadingButton>

                <LoadingButton
                  type="submit"
                  variant="outlined"
                  color="primary"
                  loadingPosition="start"
                  href="signIn"
                  sx={{
                    width: '30%',
                  }}
                >
                  Voltar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </BasicLayout>
  );
};

export default RecoverPassword;
